
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ide-praktik",
      function () {
        return require("private-next-pages/ide-praktik/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ide-praktik"])
      });
    }
  